import React, { useEffect, useMemo, useState } from "react";
import { CustomDropdown } from "../SpotOrders/spotOrderUi";
import SoMobileFilters from "./SoMobileFilters";
import OrderMobileCardShell from "./OrderMobileCardShell";
import { referralCoinMatchesPair } from "./orderFilterHelpers";
import "./QuickBuySell.css";

const ORDER_DESKTOP_COL_COUNT = 7;

const COIN_OPTIONS = [
  { value: "all", label: "All" },
  { value: "btc", label: "BTC" },
  { value: "eth", label: "ETH" },
  { value: "usdt", label: "USDT" },
];

/*
const ROWS = Array.from({ length: 6 }, (_, i) => ({
  id: i + 1,
  date: "2026-04-20 15:30",
  pair: "BTC ↔ USDT",
  payAmount: "$5,000.00",
  getAmount: "0.06020 BTC",
  fee: "$10.00",
  rate: "1 BTC = $83,000.00",
  status: "Completed",
}));
*/
const ROWS = [];

const QuickBuySell = () => {
  const [coin, setCoin] = useState("all");
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    if (!openDropdown) return undefined;
    const onDocClick = (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (!t.closest("[data-so-dropdown]")) setOpenDropdown(null);
    };
    document.addEventListener("click", onDocClick, true);
    return () => document.removeEventListener("click", onDocClick, true);
  }, [openDropdown]);

  useEffect(() => {
    if (!openDropdown) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setOpenDropdown(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [openDropdown]);

  const filteredRows = useMemo(() => {
    return ROWS.filter((r) => referralCoinMatchesPair(r.pair, coin));
  }, [coin]);

  const resetFilters = () => setCoin("all");

  const renderEmptyBody = () => (
    <tr>
      <td colSpan={ORDER_DESKTOP_COL_COUNT} className="so-table__emptyWrap">
        <div className="so-emptyState" role="status">
          <img src="/images/no-data.svg" alt="" width={120} height={144} className="so-emptyState__img" />
        </div>
      </td>
    </tr>
  );

  const renderToolbar = (stacked, keyPrefix) => {
    const pref = keyPrefix ? `${keyPrefix}-` : "";
    return (
      <div className={`so-toolbar ${stacked ? "so-toolbar--stack" : ""}`} role="search" aria-label="Filter quick buy/sell">
        <div className="so-toolbar__left">
          <CustomDropdown
            id={`${pref}qbs-dd-coin`}
            label="Coin"
            value={coin}
            options={COIN_OPTIONS}
            onChange={setCoin}
            menuKey={`${pref}qbs-coin`}
            openKey={openDropdown}
            onOpenToggle={setOpenDropdown}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="dashboard_right">
      <div className="dashboard_listing_section2 Overview_mid">
        <div className="listing_left_outer full_width transaction_history_t desktop_view2 so-desktopWrap">
          <main className="so-page" aria-labelledby="so-qbs-title">
            <h1 id="so-qbs-title" className="so-page__title">
              Quick Buy/Sell
            </h1>

            {renderToolbar(false, "desk")}

            <div className="so-tableWrap quickbuytable">
              <table className="so-table so-table--air">
                <thead>
                  <tr>
                    <th scope="col">Date</th>
                    <th scope="col">Swapping Currencies</th>
                    <th scope="col">
                      Pay Amount
                    </th>
                    <th scope="col">Get Amount</th>
                    <th scope="col">
                      Swapping Fee
                    </th>
                    <th scope="col">Conversion Rate</th>
                    <th scope="col">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRows.length === 0
                    ? renderEmptyBody()
                    : filteredRows.map((r) => (
                      <tr key={r.id}>
                        <td className="so-num">{r.date}</td>
                        <td>{r.pair}</td>
                        <td className="so-num">{r.payAmount}</td>
                        <td className="so-fillQty--pos so-num"><div className="amountgreen">{r.getAmount}</div></td>
                        <td className="so-num">{r.fee}</td>
                        <td className="so-num">{r.rate}</td>
                        <td>
                          <span className="so-status so-status--completed">{r.status}</span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </main>
        </div>

        <div className="order_history_mobile_view so-mobile">
          <h2 className="so-mobile__title">Quick Buy/Sell</h2>
          <div className="so-mobile__toolbar">
            <SoMobileFilters modalId="mob-qbs-filters" toolbar={renderToolbar(true, "mob")} onReset={resetFilters} />
          </div>
          {filteredRows.length === 0 ? (
            <div className="so-emptyState so-emptyState--mobile" role="status">
              <img src="/images/no-data.svg" alt="" width={120} height={144} className="so-emptyState__img" />
            </div>
          ) : (
            filteredRows.map((r) => (
              <OrderMobileCardShell key={`m-${r.id}`} desktopColumnCount={ORDER_DESKTOP_COL_COUNT} popupTitle="Quick buy/sell details">
                <div className="so-mobileCard__row">
                  <span>Date</span>
                  <span className="so-num">{r.date}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Pair</span>
                  <span>{r.pair}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Pay</span>
                  <span className="so-num">{r.payAmount}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Get</span>
                  <span className="so-num">{r.getAmount}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Fee</span>
                  <span className="so-num">{r.fee}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Rate</span>
                  <span className="so-num">{r.rate}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Status</span>
                  <span className="so-status so-status--completed">{r.status}</span>
                </div>
              </OrderMobileCardShell>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickBuySell;

